import { type IContent } from "@kunduz/data-access-cms-api";
import { DetailedAccordion } from "@kunduz/ui-components";
import { trackEventNext } from "@kunduz/utility-analytics";
import React, { ReactElement } from "react";

export const DetailedAccordionWithContext = (props: Props): ReactElement => {
  function handleCollapseChanged(title: string) {
    trackEventNext({ event: "Accordion Item Clicked", title });
  }

  return (
    <DetailedAccordion
      data={props.data}
      onCollapseChanged={(title) => handleCollapseChanged(title)}
    />
  );
};

interface Props {
  data: IContent.DetailedAccordionData;
}
